export const SPMTTasks = {
  SPMTApplication: "SPMT",
};
